import { gql } from "@apollo/client";

export const ANN_CREATE_QUERY = gql`mutation CreateAnnouncement($data: AnnouncementCreateInput) {
    createAnnouncement(data: $data) {
      id
    }
}`;
export const ANN_REMOVE_QUERY = gql`mutation DeleteAnnouncement($id: Int!) {
    deleteAnnouncement(id: $id) {
      id
    }
}`;
export const ANN_GET_QUERY = gql`query Announcements($skip: Int, $take: Int) {
    announcements(offset: $skip, limit: $take) {
      id
      text
      createdAt
      entouch
      assist
      title
      activatedAt
      attachment {
        label
        url
        signedUrl
      }
      createdBy {
        name
      }
    }
}`;
export const ANN_FEED_QUERY = gql`query Feed($skip: Int, $take: Int, $startDate: DateTime, $endDate: DateTime, $client: Client) {
  feed(offset: $skip, limit: $take, startDate: $startDate, endDate: $endDate, client: $client) {
    id
    text
    entouch
    assist
    title
    activatedAt
    attachment {
      label
      url
      signedUrl
    }
  }
}`;

export const SINGLE_UPLOAD = gql`
  mutation($file: Upload!) {
    singleUpload(file: $file) {
      filename
      mimetype
      encoding
      url
    }
  }
`;

export const DATE_FORMAT_UNIVERSAL = 'YYYY-MM-DD HH:mm';
export const DATE_FORMAT_US = 'MM/DD/YYYY hh:mm A';
export const PAGE_SIZE = 10;
